<template>
  <div class="relative flex flex-col py-4 h-full overflow-hidden">
    <div class="absolute inset-y-0 left-0 pt-6 flex flex-col">
      <router-link
        to="/cuestionarios"
        class="mt-4 mx-6 px-4 py-2 bg-red-500 hover:bg-danger-color rounded-lg text-gray-100 font-bold shadow-lg"
      >Regresar</router-link>
      <button
        v-on:click="onexport()"
        class="mt-4 mx-6 px-4 py-2 bg-green-500 hover:bg-primary-color rounded-lg text-gray-100 font-bold shadow-lg"
      >Descargar</button>
    </div>
    <div class="w-full h-full mt-4 overflow-auto">
      <div class="flex w-9/12 mx-auto">
        <div
          v-if="visitors.total"
          class="flex flex-col items-center justify-center w-1/3 bg-white shadow-xl rounded-lg py-6 mb-4 mr-2"
        >
          <div class="w-full text-3xl text-gray-900">{{visitors.total}}</div>
          <div class="w-full text-gray-700 uppercase tracking-widest">visitantes</div>
        </div>
        <div v-if="visitors.gender" class="w-2/3 bg-white shadow-xl rounded-lg py-6 mb-4 ml-2">
          <GenderChart
            :chartData="visitors.gender"
            :options="genderChartOptions"
            :css-classes="'w-2/3 h-64 py-2 mx-auto'"
          ></GenderChart>
        </div>
      </div>
      <div class="w-9/12 mx-auto">
        <div v-if="visitors.age" class="w-full bg-white shadow-xl rounded-lg py-6 mb-4">
          <div class="w-full">
            <div class="w-full text-3xl text-gray-900">{{visitors.age.average | round}}</div>
            <div class="w-full text-gray-700 uppercase tracking-widest">edad promedio</div>
          </div>
          <div class="w-full flex">
            <div class="w-1/2">
              <div class="w-full text-2xl text-gray-900">{{visitors.age.max}}</div>
              <div class="w-full text-sm text-gray-700 uppercase tracking-widest">edad máxima</div>
            </div>
            <div class="w-1/2">
              <div class="w-full text-2xl text-gray-900">{{visitors.age.min}}</div>
              <div class="w-full text-sm text-gray-700 uppercase tracking-widest">edad mínima</div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-9/12 mx-auto">
        <div
          v-for="question in questions"
          :key="question.question_id"
          class="w-full bg-white shadow-xl rounded-lg py-6 mb-4"
        >
          <div v-if="question.question_type === 'open'">
            <div class="text-xl text-gray-900 tracking-wider">{{question.question_text}}</div>
            <div class="flex items-center pt-2">
              <div class="w-1/3 h-64 px-8 overflow-auto text-left">
                <div
                  v-for="(answer, index) in question.result"
                  :key="index"
                  class="mb-2 p-4 text-gray-900 bg-gray-400 rounded-lg"
                >{{answer}}</div>
              </div>
              <div class="w-2/3 px-4 h-64">
                <vue-word-cloud
                  :words="question.wordcloud"
                  :color="([, weight]) => weight > 10 ? '#E53E3E' : weight > 5 ? '#DD6B20' : '#D69E2E'"
                  font-family="Roboto"
                />
              </div>
            </div>
          </div>
          <div v-if="question.question_type === 'multiple'">
            <div class="text-xl text-gray-900 tracking-wider">{{question.question_text}}</div>
            <MultipleQuestionChart
              :chartData="question.result"
              :options="chartOptions"
              :css-classes="'w-4/5 h-64 py-2 mx-auto'"
            ></MultipleQuestionChart>
          </div>
          <div v-if="question.question_type === 'scale'" class="flex flex-wrap px-3 items-center">
            <div class="w-full text-xl text-gray-900 tracking-wider">{{question.question_text}}</div>
            <div class="w-1/2 px-4 py-2">
              <ScaleQuestionChart
                :chartData="question.result"
                :options="chartOptions"
                :css-classes="'w-full h-64 py-2 mx-auto'"
              ></ScaleQuestionChart>
              <!-- <div class="w-full flex items-center">
                <div class="w-1/2 text-left">{{question.range[0]}}</div>
                <div class="w-1/2 text-right">{{question.range[1]}}</div>
              </div>
              <div class="w-11/12 h-4 mx-auto my-1 bg-gray-400 rounded-full"></div>
              <div class="w-full flex items-center">
                <div class="w-1/2 text-left">{{question.labels[0]}}</div>
                <div class="w-1/2 text-right">{{question.labels[1]}}</div>
              </div>-->
            </div>
            <div class="w-1/2 px-4 py-2">
              <div class="w-full text-3xl text-gray-900">{{question.average | round}}</div>
              <div class="w-full text-gray-700 uppercase tracking-widest">promedio</div>
            </div>
          </div>
          <div v-if="question.question_type === 'rating'">
            <div class="w-full text-xl text-gray-900 tracking-wider">{{question.question_text}}</div>
            <div class="w-full px-4 py-2">
              <div class="w-full text-3xl text-gray-900">{{question.average | round}}</div>
              <div class="w-full text-gray-700 uppercase tracking-widest">promedio</div>
            </div>
            <div class="w-full flex">
              <div class="w-1/2">
                <div class="flex w-full items-center justify-center">
                  <template v-for="icon in 5">
                    <svg
                      v-if="icon <= maxRating(question.result)"
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-8 w-8 fill-current"
                      :class="{'text-yellow-600': question.icon === 'star', 'text-red-600': question.icon === 'heart', 'text-indigo-600': question.icon === 'sentiment'}"
                      viewBox="0 0 24 24"
                      :key="icon"
                    >
                      <template v-if="question.icon === 'star'">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                        />
                        <path d="M0 0h24v24H0z" fill="none" />
                      </template>
                      <template v-else-if="question.icon === 'heart'">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                        />
                      </template>
                      <template v-else-if="question.icon === 'sentiment'">
                        <g id="Bounding_Box">
                          <rect fill="none" width="24" height="24" />
                        </g>
                        <g id="Flat">
                          <g id="ui_x5F_spec_x5F_header_copy_2" />
                          <path
                            d="M11.99,2C6.47,2,2,6.48,2,12c0,5.52,4.47,10,9.99,10C17.52,22,22,17.52,22,12C22,6.48,17.52,2,11.99,2z M8.5,8
		C9.33,8,10,8.67,10,9.5S9.33,11,8.5,11S7,10.33,7,9.5S7.67,8,8.5,8z M12,18c-2.28,0-4.22-1.66-5-4h10C16.22,16.34,14.28,18,12,18z M15.5,11c-0.83,0-1.5-0.67-1.5-1.5S14.67,8,15.5,8S17,8.67,17,9.5S16.33,11,15.5,11z"
                          />
                        </g>
                      </template>
                      <template v-else-if="question.icon === 'satisfaction'">
                        <path fill="none" d="M0 0h24v24H0V0z" />
                        <path
                          d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
                        />
                      </template>
                    </svg>
                    <svg
                      v-else
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-8 w-8 fill-current"
                      :class="{'text-yellow-600': question.icon === 'star', 'text-red-600': question.icon === 'heart', 'text-indigo-600': question.icon === 'sentiment', 'text-gray-500': question.icon === 'satisfaction'}"
                      viewBox="0 0 24 24"
                      :key="icon"
                    >
                      <template v-if="question.icon === 'star'">
                        <path
                          d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                        />
                        <path d="M0 0h24v24H0z" fill="none" />
                      </template>
                      <template v-else-if="question.icon === 'heart'">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
                        />
                      </template>
                      <template v-else-if="question.icon === 'sentiment'">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                        />
                      </template>
                      <template v-else-if="question.icon === 'satisfaction'">
                        <path fill="none" d="M0 0h24v24H0V0z" />
                        <path
                          d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
                        />
                      </template>
                    </svg>
                  </template>
                </div>
                <div class="w-full py-1 tracking-widest">Calificación máxima</div>
              </div>
              <div class="w-1/2">
                <div class="flex w-full items-center justify-center">
                  <template v-for="icon in 5">
                    <svg
                      v-if="icon <= minRating(question.result)"
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-8 w-8 fill-current"
                      :class="{'text-yellow-600': question.icon === 'star', 'text-red-600': question.icon === 'heart', 'text-indigo-600': question.icon === 'sentiment'}"
                      viewBox="0 0 24 24"
                      :key="icon"
                    >
                      <template v-if="question.icon === 'star'">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                        />
                        <path d="M0 0h24v24H0z" fill="none" />
                      </template>
                      <template v-else-if="question.icon === 'heart'">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                        />
                      </template>
                      <template v-else-if="question.icon === 'sentiment'">
                        <g id="Bounding_Box">
                          <rect fill="none" width="24" height="24" />
                        </g>
                        <g id="Flat">
                          <g id="ui_x5F_spec_x5F_header_copy_2" />
                          <path
                            d="M11.99,2C6.47,2,2,6.48,2,12c0,5.52,4.47,10,9.99,10C17.52,22,22,17.52,22,12C22,6.48,17.52,2,11.99,2z M8.5,8
		C9.33,8,10,8.67,10,9.5S9.33,11,8.5,11S7,10.33,7,9.5S7.67,8,8.5,8z M12,18c-2.28,0-4.22-1.66-5-4h10C16.22,16.34,14.28,18,12,18z M15.5,11c-0.83,0-1.5-0.67-1.5-1.5S14.67,8,15.5,8S17,8.67,17,9.5S16.33,11,15.5,11z"
                          />
                        </g>
                      </template>
                      <template v-else-if="question.icon === 'satisfaction'">
                        <path fill="none" d="M0 0h24v24H0V0z" />
                        <path
                          d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
                        />
                      </template>
                    </svg>
                    <svg
                      v-else
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-8 w-8 fill-current"
                      :class="{'text-yellow-600': question.icon === 'star', 'text-red-600': question.icon === 'heart', 'text-indigo-600': question.icon === 'sentiment', 'text-gray-500': question.icon === 'satisfaction'}"
                      viewBox="0 0 24 24"
                      :key="icon"
                    >
                      <template v-if="question.icon === 'star'">
                        <path
                          d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                        />
                        <path d="M0 0h24v24H0z" fill="none" />
                      </template>
                      <template v-else-if="question.icon === 'heart'">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
                        />
                      </template>
                      <template v-else-if="question.icon === 'sentiment'">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                        />
                      </template>
                      <template v-else-if="question.icon === 'satisfaction'">
                        <path fill="none" d="M0 0h24v24H0V0z" />
                        <path
                          d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
                        />
                      </template>
                    </svg>
                  </template>
                </div>
                <div class="w-full py-1 tracking-widest">Calificación mínima</div>
              </div>
            </div>
            <div class="w-full">
              <RatingQuestionChart
                :chartData="question.result"
                :options="chartOptions"
                :css-classes="'w-2/3 h-64 py-2 mx-auto'"
              ></RatingQuestionChart>
            </div>
          </div>
          <div v-if="question.question_type === 'multimedia'">
            <div class="text-xl text-gray-900 tracking-wider">{{question.question_text}}</div>
            <multimedia-gallery :medias="question.result"></multimedia-gallery>
          </div>
          <div v-if="question.question_type === 'geolocation'">
            <div class="text-xl text-gray-900 tracking-wider">{{question.question_text}}</div>
            <div class="flex pt-2">
              <div class="h-80 w-full">
                <l-map
                  class="h-full w-full z-0"
                  :zoom="zoom"
                  :minZoom="11"
                  :center="center"
                  :options="{zoomControl: false}"
                >
                  <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                  <l-geo-json :geojson="polygon" :options-style="geoStyle" />

                  <l-marker
                    v-for="(result, index) in question.result"
                    :key="index"
                    :lat-lng="[result.lat, result.lng]"
                  ></l-marker>
                </l-map>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import VueWordCloud from "vuewordcloud";
import MultipleQuestionChart from "./MultipleQuestionChart";
import ScaleQuestionChart from "./ScaleQuestionChart";
import RatingQuestionChart from "./RatingQuestionChart";
import GenderChart from "./GenderChart";
import MultimediaGallery from "./MultimediaGallery";

import polygon from "../assets/polygonChapp.json";

import L from "leaflet";
import { LMap, LTileLayer, LMarker, LGeoJson } from "vue2-leaflet";
import * as esri from "esri-leaflet";

import { Icon } from "leaflet";
import XLSX from 'xlsx';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default {
  name: "form-answers",
  data() {
    return {
      formId: null,
      questions: null,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      chartOptions: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200
      },
      visitors: {},
      genderChartOptions: {
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200
      },
      polygon: polygon,
      zoom: 13,
      center: [19.412257, -99.200871],
      geoStyle: {
        color: "#cb2833",
        fill: false
      },
      name,
      url:
        "https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}",
      attribution: "Esri, HERE, Garmin, INCREMENT P, USGS, METI/NASA, EPA, USDA"
    };
  },
  components: {
    //[VueWordCloud.name]: VueWordCloud,
    MultipleQuestionChart,
    ScaleQuestionChart,
    RatingQuestionChart,
    GenderChart,
    MultimediaGallery,
    LMap,
    LTileLayer,
    LMarker,
    LGeoJson
  },
  mounted() {
    this.formId = this.$route.params.id;
    this.fetchFormAnswers(this.formId);
  },
  methods: {
    onexport () {
      this.axios
        .get("apidev/api/polls/answer/getanswers/"+this.formId, this.config)
        .then(response => {
          let answer_question = [];
          response.data.forEach((answer) => {
            // removed console log
            let info = {
              "nivel de estudios": answer.nivel_estudios,
              edad: answer.age,
              sexo: answer.sex
            }

            answer.respuestas.forEach((question)=>{
              if(this.questions.hasOwnProperty(question.id)){
                const select_question = this.questions[question.id];
                const type = select_question.question_type;
                const key = select_question.question_text;
                switch(type){
                  case 'geolocation':
                    info[key] = `${question.answer.lat},${question.answer.lng}`;
                    break;
                  case 'multimedia':
                    info[key] = `apidev/uploads/surveys/${question.answer}`;
                    break;
                  case 'matrix':
                    if (typeof question.answer === 'object') {
                      Object.keys(question.answer).forEach(rowKey => {
                        info[`${key} - ${rowKey}`] = question.answer[rowKey];
                      });
                    }
                    break;
                  default: 
                    info[key] = question.answer;
                    break;
                }
              }
            })
            answer_question.push(info);
          });

          const visitors = {
            'Edad maxima': this.visitors.age.max,
            'Edad minima': this.visitors.age.min,
            'Edad promedio': this.visitors.age.average,
            'Hombres': this.visitors.gender.H,
            'Mujeres': this.visitors.gender.M,
            // 'Indefinido': this.visitors.gender.U,
          };

          let questionOpen = [];
          let questionMultiple = [];
          let questionGeolocation = [];
          let questionRaiting = [];
          let questionScale = [];
          let questionMultimedia = [];
          let questionMatrix = [];

          const valuesOnly = Object.values(this.questions);
          valuesOnly.forEach(question => {
            switch(question.question_type){
              case 'open':
                question.result.forEach((answer)=>{
                  const newQuestionOpen = {
                    Pregunta: question.question_text,
                    Respuesta: answer,
                  };
                  questionOpen.push(newQuestionOpen);
                })
                break;
              case 'multiple':
                Object.keys(question.result).forEach((key)=>{
                  const newQuestionMultiple = {
                    Pregunta: question.question_text,
                    'Opcion Multiple':  key,
                    Respuesta: question.result[key],
                  };
                  questionMultiple.push(newQuestionMultiple);
                })
                break;
              case 'geolocation':
                Object.keys(question.result).forEach((key)=>{
                  const newQuestionGeolocation = {
                    Pregunta: question.question_text,
                    Latitud: question.result[key].lat,
                    Longitud: question.result[key].lng,
                  };
                  questionGeolocation.push(newQuestionGeolocation);
                })
                break;
              case 'rating':
                Object.keys(question.result).forEach((key)=>{
                  const newQuestionRaiting = {
                    Pregunta: question.question_text,
                    'Escala':  key,
                    Respuesta: question.result[key],
                  };
                  questionRaiting.push(newQuestionRaiting);
                })
                break;
              case 'scale':
                Object.keys(question.result).forEach((key)=>{
                  const newQuestionScale = {
                    Pregunta: question.question_text,
                    'Escala':  key,
                    Respuesta: question.result[key],
                  };
                  questionScale.push(newQuestionScale);
                })
                break;
              case 'multimedia':
                question.result.forEach((result)=>{
                  const newQuestionMultimedia = {
                    Pregunta: question.question_text,
                    'Tipo de pregunta':  question.multimedia_type='photo' ? 'imagen' : 'video',
                    Result: `apidev/uploads/surveys/${result.filename}`,
                    'Tipo de respuesta': result.type,
                  };
                  questionMultimedia.push(newQuestionMultimedia);
                })
                break;
              case 'matrix':
                if (question.result && typeof question.result === 'object') {
                  Object.keys(question.result).forEach((rowKey)=>{
                    if (typeof question.result[rowKey] === 'object') {
                      Object.keys(question.result[rowKey]).forEach((colKey)=>{
                        const newQuestionMatrix = {
                          Pregunta: question.question_text,
                          Fila: rowKey,
                          Columna: colKey,
                          Respuestas: question.result[rowKey][colKey],
                        };
                        questionMatrix.push(newQuestionMatrix);
                      });
                    }
                  });
                }
                break;
              default:
                break;
            }
          });

          const visitorInfo = XLSX.utils.json_to_sheet([visitors]);
          const answerList = answer_question.length > 0 ? XLSX.utils.json_to_sheet(answer_question): null;
          const questionOpenList = questionOpen.length > 0 ? XLSX.utils.json_to_sheet(questionOpen): null;
          const questionMultipleList = questionMultiple.length >0 ? XLSX.utils.json_to_sheet(questionMultiple): null;
          const questionGeolocationList = questionGeolocation.length >0 ? XLSX.utils.json_to_sheet(questionGeolocation): null;
          const questionRaitingList = questionRaiting.length >0 ? XLSX.utils.json_to_sheet(questionRaiting): null;
          const questionScaleList = questionScale.length >0 ? XLSX.utils.json_to_sheet(questionScale): null;
          const questionMultimediaList = questionMultimedia.length >0 ? XLSX.utils.json_to_sheet(questionMultimedia): null;
          const questionMatrixList = questionMatrix.length >0 ? XLSX.utils.json_to_sheet(questionMatrix): null;

          var wb = XLSX.utils.book_new();

          XLSX.utils.book_append_sheet(wb, visitorInfo, "Información General");
          if(answerList) XLSX.utils.book_append_sheet(wb, answerList, "Respuestas");
          if(questionOpenList) XLSX.utils.book_append_sheet(wb, questionOpenList, "Preguntas Abiertas");
          if(questionMultipleList) XLSX.utils.book_append_sheet(wb, questionMultipleList, "Preguntas Cerradas");
          if(questionGeolocationList) XLSX.utils.book_append_sheet(wb, questionGeolocationList, "Preguntas Geolocalización");
          if(questionRaitingList) XLSX.utils.book_append_sheet(wb, questionRaitingList, "Preguntas de Calificación");
          if(questionScaleList) XLSX.utils.book_append_sheet(wb, questionScaleList, "Preguntas de Escala lineal");
          if(questionMultimediaList) XLSX.utils.book_append_sheet(wb, questionMultimediaList, "Preguntas de Multimedia");
          if(questionMatrixList) XLSX.utils.book_append_sheet(wb, questionMatrixList, "Preguntas de Matriz");

          XLSX.writeFile(wb, "Cuestionario.xlsx");

          this.axios.post("apidev/api/binnacles/monitor/save/",{
            "module": "Encuestas", 
            "action": "Descarga de respuestas de una encuesta", 
            "observation": `${this.name}`,
            "email": localStorage.getItem("email")
            },
            this.config
          )
          .then(response => {
            //// removed console log
          })
          .catch(error => {
            //// removed console log
          });
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.errored = true;
        })
    },
    fetchFormAnswers(formId) {
      this.axios
        .get(
          "apidev/api/polls/answer/getresults/" + formId,
          this.config
        )
        .then(response => {
          this.name = response.data.name;
          this.questions = response.data.questions;
          this.visitors = response.data.visitors;
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    maxRating(result) {
      let lastIndex = Object.keys(result).length - 1;
      return Object.keys(result)[lastIndex];
    },
    minRating(result) {
      return Object.keys(result)[0];
    }
  },
  filters: {
    round(value) {
      if (value) return Number(value.toFixed(2));
    }
  }
};
</script>

<style scoped>
</style>
